import { version } from "@/../package.json";
import { useTranslation } from "@/i18n";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="bg-sidebar text-sidebar-foreground border-t px-4 py-6 md:py-0">
      <div className="flex w-full flex-col items-center justify-between gap-4 md:h-16 md:flex-row [&>*]:flex-1">
        <div className="flex justify-start">
          <img
            src="/begambleaware.png"
            alt={t("common.beGambleAware")}
            className="h-4 invert dark:invert-0"
          />
        </div>
        <div className="flex flex-col justify-center">
          <div className="text-muted-foreground text-center text-sm">
            {t("common.copyright", { year: currentYear })}
          </div>
          <div className="text-muted-foreground text-center text-xs">
            {t("common.version", { version })}
          </div>
        </div>

        <div className="flex justify-end">
          <img
            src="/praxislogo.png"
            alt={t("common.praxisLogo")}
            className="h-8 invert dark:invert-0"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
